import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom"
import Context from "../../Context";

import AssemblyComponent from "../../Components/AssemblyComponent";
import { uniqueId } from "lodash";

interface PaginaT {
    id: number,
    nome: string,
    slug: string,
    componentes: Array<ComponentesT>
    created_at: Date,
    updated_at: Date
}

interface PivotT {
    props?: string
}

interface ComponentesT {
    id: number,
    nome: string,
    pivot?: PivotT,
    created_at: Date,
    updated_at: Date
}

const Assembly = () => {
    const { resumo } = useContext(Context);
    const location = useLocation();

    const [pagina, setPagina] = useState<PaginaT | false | undefined>();

    useEffect(() => {
        let route = location.pathname.length > 1 ? location.pathname : "/home";
        route = route.replace(/\/+$/, '');
        let pagina: Array<PaginaT> = resumo?.paginas.filter((obj: PaginaT) => {
            return `/${obj.slug}` === route;
        });

        if (pagina.length > 0) {
            setPagina(pagina[0]);
        } else {
            setPagina(false)
        }
    }, [location]);

    return (
        <div>
            {pagina === false ? "Página não encontrada!" : <></>}
            {pagina !== false && pagina !== undefined ?
                <div>
                    {pagina.componentes.map(componente => {
                        return <AssemblyComponent key={uniqueId("comp_")} id={componente.nome} props={componente.pivot?.props} />;
                    })}
                </div>
                : <></>
            }
        </div>
    )
}

export default Assembly;